import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

window.addEventListener( 'load', function () {
	const carousels = document.querySelectorAll( '.cta-carousel' );

	if ( 0 < carousels.length ) {
		Swiper.use( [ Navigation, Scrollbar ] );
		carousels.forEach( function ( carousel ) {
			new Swiper( carousel, {
				slidesPerView: 1.2,
				slideClass: 'cta-page-block',
				spaceBetween: 25,
				scrollbar: {
					el: carousel.querySelector( '.swiper-scrollbar' ),
					draggable: true,
				},
				navigation: {
					prevEl: carousel.querySelector( '.swiper-button-prev' ),
					nextEl: carousel.querySelector( '.swiper-button-next' ),
				},
				breakpoints: {
					640: {
						slidesPerView: 2.3,
					},
					1080: {
						slidesPerView: 3.1,
					},
					1600: {
						slidesPerView: 3.79,
					},
				},
			} );
		} );
	}
} );

document.addEventListener('DOMContentLoaded', () => {
	const isFrench = document.documentElement.lang.toLowerCase().includes('fr');

	const reserveTicketsBtn = document.getElementById('tribe-tickets__tickets-submit');

	if (reserveTicketsBtn) {
		reserveTicketsBtn.textContent = isFrench ? 'Réserver les billets' : 'Book the tickets';
	}
});